import { accordionClasses } from '@mui/material/Accordion';
import { accordionSummaryClasses } from '@mui/material/AccordionSummary';
import { Theme } from '@mui/material/styles';
import { typographyClasses } from '@mui/material/Typography';

// ----------------------------------------------------------------------

declare module '@mui/material/Paper' {
  interface PaperPropsVariantOverrides {
    rounded: true;
  }
}

export function accordion(theme: Theme) {
  return {
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
          [`&.${accordionClasses.disabled}`]: {
            backgroundColor: 'transparent',
          },
          [`&.${accordionClasses.expanded}`]: {
            marginTop: 0,
            marginBottom: 0,
          },
        },
        rounded: {
          [`&.${accordionClasses.root}`]: {
            borderRadius: theme.shape.borderRadiusLg,
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          [`&.${accordionSummaryClasses.disabled}`]: {
            opacity: 1,
            color: theme.palette.action.disabled,
            [`& .${typographyClasses.root}`]: {
              color: 'inherit',
            },
          },
        },
        expandIconWrapper: {
          color: 'inherit',
        },
      },
    },
  };
}
